import { ANIMATION, MEDIA_PLAYING, EVENT } from '../constants';
import attachEventOnScreenOrientationChang from '../helpers/attach-event-on-orientation-change';

const TOOLBAR_TRIGGER_OFFSET = 60;

const animatePlayButtonOnResponsive = (): void => {
    const playBtnAlt = document.querySelector<HTMLDivElement>('.js-media-controls__play--alt');
    const playBtnAltText = playBtnAlt?.querySelector<HTMLSpanElement>('.js-media-controls__play--alt-text');
    playBtnAlt?.classList.add('hide-text-container');
    playBtnAltText?.classList.add('hide-text');
};

const shouldToolbarBeHidden = (mediaCnt: HTMLDivElement): boolean => {
    return !(window.innerHeight - mediaCnt.getBoundingClientRect().height > TOOLBAR_TRIGGER_OFFSET);
};

const toggleToolbarOnEvents = (mediaCnt: HTMLDivElement, profileCnt: HTMLDivElement | null): void => {
    const responsiveToolbar = document.querySelector<HTMLDivElement>('.js-toolbar');
    const toggleToolbarVisibility = () => {
        if (shouldToolbarBeHidden(mediaCnt) && profileCnt?.classList.contains(MEDIA_PLAYING)) {
            responsiveToolbar?.classList.remove(ANIMATION.FADE_IN_FAST);
            responsiveToolbar?.classList.add(ANIMATION.FADE_OUT_FAST);
        } else {
            responsiveToolbar?.classList.remove(ANIMATION.FADE_OUT_FAST);
            responsiveToolbar?.classList.add(ANIMATION.FADE_IN_FAST);
        }
    };

    window.addEventListener('resize', toggleToolbarVisibility);
    attachEventOnScreenOrientationChang(toggleToolbarVisibility);

    document.addEventListener('scroll', (e: Event) => {
        const offset: number | undefined = document.querySelector<HTMLHtmlElement>('html')?.scrollTop;

        if (shouldToolbarBeHidden(mediaCnt) && profileCnt?.classList.contains(MEDIA_PLAYING)) {
            if (offset && offset > TOOLBAR_TRIGGER_OFFSET) {
                responsiveToolbar?.classList.remove(ANIMATION.FADE_OUT_FAST);
                responsiveToolbar?.classList.add(ANIMATION.FADE_IN_FAST);
            } else {
                responsiveToolbar?.classList.add(ANIMATION.FADE_OUT_FAST);
                responsiveToolbar?.classList.remove(ANIMATION.FADE_IN_FAST);
            }
        }
    });

    mediaCnt.addEventListener(EVENT.MEDIA_PLAY, () => {
        if (shouldToolbarBeHidden(mediaCnt)) {
            responsiveToolbar?.classList.add(ANIMATION.FADE_OUT_FAST);
        }
    });

    mediaCnt.addEventListener(EVENT.MEDIA_PAUSE, () => {
        responsiveToolbar?.classList.remove(ANIMATION.FADE_IN_FAST, ANIMATION.FADE_OUT_FAST);
    });

    mediaCnt.addEventListener(EVENT.MEDIA_CLOSE, () => {
        responsiveToolbar?.classList.remove(ANIMATION.FADE_IN_FAST, ANIMATION.FADE_OUT_FAST);
    });
};

export { animatePlayButtonOnResponsive, toggleToolbarOnEvents };
